exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/morne/Documents/dev/remindworks-docs/src/app/swagger/swagger.component.css
// module id = ../../../../../src/app/swagger/swagger.component.css
// module chunks = main